import {ValuePropType} from "../../../../../Types/Homepage/ValuePropType";
import {ValueProp, Props as ValuePropProps} from "../Layouts/ValuePropListLayout/ValueProp";
import React from "react";

export type Props = {
	Layout: any
	valueProps: Array<ValuePropType>
}

export const generateValueProps = (props: Props) =>
{
	const returnValue = props.valueProps.map((prop, index) => {
		const outgoingProps: ValuePropProps = {
			valueProp: prop
		}
		const Layout = props.Layout;
		let innerReturnValue = (
			<Layout {...outgoingProps} />
		);
		return innerReturnValue
	})
	return returnValue;
}
